import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import JournalPartnerTagAdminForm from '../containers/JournalPartnerTagAdminFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';
import {
  MixpanelTracker,
  mixpanelEventsEnum,
} from '../../../../../lib/Mixpanel';

class JournalPartnerTagAdminEditScreen extends Component {
  scrollToTop = () => {
    Logger.log('debug', `JournalPartnerTagAdminEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  trackerActions = (eventMixpanel, params = {}) => {
    if (this.props.role !== 1) {
      MixpanelTracker.mixpanelTrack(eventMixpanel, {
        partnershipName: this.props.partnershipName ?? 'No partnership',
        partnershipId: this.props.partnershipId ?? 'No partnership',
        ...params,
      });
    }
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <div>
            <DocumentHead title={t('journal_partner_tag_route_edit')} />
            <JournalPartnerTagAdminForm
              id={this.props.match.params.id}
              trackerActions={this.trackerActions}
            />
          </div>
        )}
      </Translation>
    );
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
    this.trackerActions(
      mixpanelEventsEnum.ACTIONS_PARTNER.JOURNAL_PARTNER_TAGS_ADMIN_EDIT_SCREEN
    );
  }
}

export default JournalPartnerTagAdminEditScreen;

Logger.log('silly', `JournalPartnerTagAdminEditScreen loaded.`);
